import type { FaireProductEntity } from "../../entity_types/product";

export const p_nsf4r3ja7c: FaireProductEntity = {
  token: "p_nsf4r3ja7c",
  type: "product",
  name: "Women's Elegant Color Blocked Knit Cardigan",
  brandToken: "b_hrmradn4yd",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/50000bac6e92f30919886723d03a9fd5f34120bc179084a660ce568ff27b6bb5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85fea3c52d4be8d689fda51d91f1d99c522bd401fac93a4b76cb6ce240cd4004.jpeg",
    "https://cdn.faire.com/fastly/f458488482f94d1074bdea39156a0542f72d96caa2d79d68e4e25e47ea1f9d43.jpeg",
    "https://cdn.faire.com/fastly/7bd803a8c2ba34fc80c31822a27ddd6f22e1644af1e860a27ea6680ff86daa7a.jpeg",
    "https://cdn.faire.com/fastly/5fecc6119b84eb1fdff70f8cb1f38ff47bf4a85302a5428f12fdfc08348d3e19.jpeg",
    "https://cdn.faire.com/fastly/72fbae4766c4552dcb131c614eb5618fd63593111f807ed1c78b788cb32f4d07.jpeg",
    "https://cdn.faire.com/fastly/d28f502487d0fcaba79b9084a4d4f893c7917723420649446a7f87c51e1b1023.jpeg",
    "https://cdn.faire.com/fastly/ad06ac889e67355aefae2ea3025ac75ae12b441d81e2ddaec07c578156c274dd.jpeg",
    "https://cdn.faire.com/fastly/1437b8dd5964349d536f4ea49aa053a12ef026a8a469c6bb04612a156be8d7db.jpeg",
    "https://cdn.faire.com/fastly/35de7eaa9b35404d05fc7d5800b657a9e3206f06d1689b97af4fbcc16528f6a5.png",
  ],
  priceDollars: 30.06,
  description:
    "Our Women's Elegant Color Blocked Knit Cardigan is a standout addition to your wardrobe. This EmberLoom creation, custom-designed by Mrwolf, effortlessly combines style and comfort. Its color-blocked design adds a unique twist to the cardigan, making it a versatile piece that can be worn in various settings. Whether you're heading to the office or an outing, this knit cardigan will keep you looking chic and feeling cozy.",
  tags: [],
  msrpDollars: 60.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:11.040Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
